import TopicsTile from "./Generics/Topics"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileSummarySettingsModal } from "./TileSummarySettingsModal"

export default function ModelsSummaryTile({
  canEdit,
  isTemplate,
  overview,
  tileFetchParams,
  isDoubleColumn,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  return (
    <TopicsTile
      title={tile.name}
      tileId={tileFetchParams.id}
      data={tile.data ? [tile.data] : []}
      fields={tile.fields}
      breakoutLink={tile.breakout_link}
      overviewId={overview.id}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      showDummyData={isTemplate}
      canEdit={canEdit}
      isDoubleColumn={isDoubleColumn}
    />
  )
}
